export default class CartData{
  constructor() {}

  get(){
    let data = localStorage.getItem('smartz_cart_data');
    data = data ? data : '';
    let arr = [];
    try{
        if(data){
          arr = JSON.parse(data);
        }
    }catch (e) {
      console.log(e)
    }

    return arr;
  }

  set(data){
    localStorage.setItem('smartz_cart_data', JSON.stringify(data));
  }

  remove(){
    localStorage.removeItem('smartz_cart_data');
  }
}



// WEBPACK FOOTER //
// ./src/utils/localData/index.js